import Global from "../../../components/Atomos/Icons/Global";
import { NETWORKING_BANDS } from "./networkingMapBands";

export default function NetworkingMapLevelLegend() {
  return (
    <section className="flex flex-col gap-8 self-stretch lg:flex-row lg:items-center">
      <div className="inline-flex w-fit shrink-0 items-center gap-2 rounded-lg bg-primary-light px-4 py-2">
        <Global className="h-5 w-5 shrink-0 text-primary" />
        <span className="font-['Roboto'] text-base font-semibold leading-normal text-gray-font">
          Connections
        </span>
      </div>

      <div className="flex min-w-0 flex-1 flex-col gap-6 sm:flex-row sm:items-start">
        {NETWORKING_BANDS.map((band) => (
          <div key={band.key} className="min-w-0 flex-1">
            <p className="font-['Roboto'] text-xs font-semibold leading-normal text-gray-font">
              {band.label}
            </p>
            <p className="font-['Roboto'] text-xs font-normal italic leading-normal text-gray-font">
              {band.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
